import React, { Component } from "react";
import { Subscribe } from "unstated";

import buttonActionHelper from "../../../utils/helpers/buttonActionHelper";
import StateContainer from "../../../state/StateContainer";
import stringHelper from "../../../utils/helpers/stringHelper";

class NavbarButton extends Component {
  state = {
    isHovered: false,
  };

  render() {
    const button = this.props.buttonData;
    const { buttonContent } = this.props;

    const returnBackgroundColor = (className) => {
      if (className === "navbar-button button button-navbar-active" || this.state.isHovered) 
        return stringHelper.removeAplhaFromColor(this.props.unstated.state.menuColorSecondary);
      
      return (
        this.props.unstated.state.menuColor
      );
    }

    return (
      <button
        className={`navbar-button ${this.props.buttonClass}`}
        style={{
          backgroundImage: `Url(${
            this.state.isHovered
              ? button.hoverIconUrl
                ? button.hoverIconUrl
                : button.iconUrl
              : button.iconUrl
          })`,
          backgroundColor: returnBackgroundColor(`navbar-button ${this.props.buttonClass}`),
          fontSize: `${buttonContent.length>3?10:16}pt`
        }}
        key={button.name}
        onClick={() => {
          buttonActionHelper.executeActions(
            button.actions,
            this.props.unstated,
            "click"
          );
        }}
        onMouseEnter={() => {
          this.setState({ isHovered: true });
          buttonActionHelper.executeActions(
            button.actions,
            this.props.unstated,
            "mouseenter"
          );
        }}
        onMouseLeave={() => {
          this.setState({ isHovered: false });
          buttonActionHelper.executeActions(
            button.actions,
            this.props.unstated,
            "mouseleave"
          );
        }}
      >
        {buttonContent}
      </button>
    );
  }
}

const NavbarButtonWithUnstated = (props) => {
  return (
    <Subscribe to={[StateContainer]}>
      {unstated => <NavbarButton {...props} unstated={unstated}/>}
    </Subscribe>
  )
}

export default NavbarButtonWithUnstated;
